import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate, useNavigationType, useSearchParams } from "react-router-dom";
import BranchService from "src/Services/API/branch.service";
import BranchButton from "./BranchButton";
import { isAccountant, isAdmin, isManager, isManagerOver, isProjectManager } from "src/Common/function";
import UserService from "src/Services/API/user.service";

const BranchBar = ({ allEnabled = true, availableBranches }) => {
  const currentUser = UserService.getCurrentUser();
  const dispatch = useDispatch();
  const location = useLocation();
  const [branches, setBranches] = useState([]);
  const navigate = useNavigate();
  const navigationType = useNavigationType();
  const [searchParams] = useSearchParams();
  const branch = Number(searchParams.get("branch"));

  useEffect(() => {
    BranchService.getAll()
      .then((response) => {
        let temp = [];
        if (allEnabled) {
          temp = [{ id: 0, name: "All" }];
        }
        //show only branches that the user is assigned to
        if (!isAdmin()) {
          temp = temp.concat(response.data.filter((b) => currentUser.branches.some((b2) => b2.id == b.id)));
        } else {
          temp = temp.concat(response.data);
        }
        setBranches(temp);
      })
      .catch((error) => {
        console.log("getting branch error: ", error);
      });
  }, []);

  useEffect(() => {
    if (branches.length > 0) {
      console.log("AAA: ", branch);
      if (isManagerOver() || isAccountant()) {
        if (branch) {
          branchClicked(branches.findIndex((b) => b.id == branch));
        } else {
          console.log("branch is 0");
          branchClicked(0);
        }
      }
    }
  }, [branches]);

  const branchClicked = (index) => {
    let url = "";
    if (branches[index].name === "All") {
      if (navigationType === "POP") {
        url = appendQueryParam("branch", "0");
      } else {
        url = appendQueryParam("branch", "0", "criteria");
      }
    } else {
      if (navigationType === "POP") {
        url = appendQueryParam("branch", branches[index].id);
      } else {
        url = appendQueryParam("branch", branches[index].id, "criteria");
      }
    }
    navigate(url, { replace: true });
  };

  const appendQueryParam = (query, value, queryToRemove) => {
    const currentPath = location.pathname;
    const currentSearch = location.search;

    const url = new URLSearchParams(currentSearch);
    url.set(query, value); // replaces or adds branch=0
    if (queryToRemove) {
      url.delete(queryToRemove);
    }

    return `${currentPath}?${url.toString()}`;
  };

  return (
    <div className="w-full flex items-center gap-2">
      {branches.map((b, index) => (
        <div key={index}>
          <BranchButton title={b.name} index={index} clicked={branchClicked} selected={branch == b.id} />
        </div>
      ))}
    </div>
  );
};

export default BranchBar;
